'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jacketShape = exports.ratingShape = exports.seriesShape = undefined;

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var seriesShape = exports.seriesShape = _reactImmutableProptypes2.default.mapContains({
  name: _react.PropTypes.string,
  sortName: _react.PropTypes.string,
  volume: _react.PropTypes.string,
  volumeNumber: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number])
});

var ratingShape = exports.ratingShape = _reactImmutableProptypes2.default.mapContains({
  averageRating: _react.PropTypes.number,
  totalCount: _react.PropTypes.number
});

var jacketShape = exports.jacketShape = _reactImmutableProptypes2.default.mapContains({
  large: _react.PropTypes.string,
  local_url: _react.PropTypes.string,
  medium: _react.PropTypes.string,
  small: _react.PropTypes.string,
  type: _react.PropTypes.string
});

exports.default = _reactImmutableProptypes2.default.mapContains({
  authors: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  callNumber: _react.PropTypes.string,
  consumptionFormat: _react.PropTypes.string,
  description: _react.PropTypes.string,
  edition: _react.PropTypes.string,
  format: _react.PropTypes.string,
  id: _react.PropTypes.string,
  isbns: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  jacket: jacketShape,
  metadataId: _react.PropTypes.string,
  multiscriptAuthor: _react.PropTypes.string,
  multiscriptTitle: _react.PropTypes.string,
  primaryLanguage: _react.PropTypes.string,
  publicationDate: _react.PropTypes.string,
  rating: ratingShape,
  series: _reactImmutableProptypes2.default.listOf(seriesShape),
  subtitle: _react.PropTypes.string,
  superFormats: _reactImmutableProptypes2.default.listOf(_react.PropTypes.string),
  title: _react.PropTypes.string
});


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/bc-prop-types/lib/components/bibBriefShape.js
// module id = 40
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14